import { useCallback } from "react";
import { useProgress } from "@devowl-wp/real-queue";
import { useStores } from "../store/stores.js";
import { SCAN_QUEUE_JOB } from "../types/queue.js";
/**
 * Returns the status / progress of the scanner.
 */ function useScannerProgress(fetchStatusInterval, fetchAdditionalData = false, onCancel) {
    const { scannerStore } = useStores();
    return useProgress({
        type: SCAN_QUEUE_JOB,
        fetchStatusInterval,
        fetchAdditionalData,
        onAdditionalData: useCallback(({ "rcb-scan-list": rcbScanList })=>{
            const { templates, externalUrls } = rcbScanList;
            scannerStore.resultTemplatesFromResponse(templates);
            scannerStore.resultExternalUrlsFromResponse(externalUrls);
        }, [
            scannerStore
        ]),
        onCancel
    });
}
export { useScannerProgress };
